import React from "react";
import { autobind } from "react-decoration";
import { inject, observer } from "mobx-react";
import cateAPI from "lib/cateAPI";

@inject("appStore", "readerStore")
@observer
class ListCateComp2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  @autobind
  addCate(e) {
    e.preventDefault();
    if (this.props.readerStore.auth) {
      cateAPI
        .addCate(this.props.id, this.props.resourceType, "")
        .then((data) => {
          if (data !== null && data !== undefined) {
            if (data.data.mutation.success) {
              // 更新 appStore 的收藏狀態
              this.props.appStore.setCollection(this.props.id, this.props.resourceType);
              if (this.props.refetch !== null) {
                this.props.refetch();
              }
            }
          }
        });
    } else {
      this.props.appStore.openLogin();
    }
  }

  @autobind
  delCate(e) {
    e.preventDefault();
    if (this.props.readerStore.auth) {
      cateAPI.delCate(this.props.id, this.props.resourceType).then((data) => {
        if (data !== null && data !== undefined) {
          if (data.data.mutation.success) {
            // 更新 appStore 的收藏狀態
            this.props.appStore.removeCollection(this.props.id, this.props.resourceType);
            if (this.props.refetch !== null) {
              this.props.refetch();
            }
          }
        }
      });
    } else {
      this.props.appStore.openLogin();
    }
  }

  render() {
    let { id, resourceType, appStore } = this.props;
    // 直接從 appStore 讀取收藏狀態，MobX 會自動追蹤變化
    const isAdded = appStore.isInCollection(id, resourceType) ? 1 : 0;
    return (
      <>
        {isAdded === 0 && (
          <button
            type="button"
            tabIndex="0"
            className="icon-bookmark"
            id={"addCate_" + this.props.id}
            title={this.props.t("jumperrwd.common.addfavorites")}
            aria-label={this.props.t("jumperrwd.common.addfavorites")}
            onClick={this.addCate}></button>
        )}
        {isAdded !== 0 && (
          <button
            type="button"
            tabIndex="0"
            className="icon-bookmark added"
            id={"delCate_" + this.props.id}
            title={this.props.t("jumperrwd.common.delfavorites")}
            aria-label={this.props.t("jumperrwd.common.delfavorites")}
            onClick={this.delCate}></button>
        )}
      </>
    );
  }
}

export default ListCateComp2;
